const infosKey = 'key_infos'
const INITIAL_STATE = {
	content: [],
	infos: (localStorage.getItem(infosKey) !== 'undefined') ? JSON.parse(localStorage.getItem(infosKey)) : [],
	loading: false,
	lineClass: ''
}

const mainReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case 'STATICAL_CONTENT_FETCH':
			return {
				...state,
				infos: action.payload
			}
		case 'INITIAL_CONTENT_FETCH':
			return {
				...state, 
				content: action.payload
			}
		case 'LOADING':
			return {
				...state,
				loading: action.payload
			}
		case 'MENU_OPEN':
			return {
				...state,
				lineClass: action.payload
			}
		default:
			return state
	}
}

export default mainReducer